export const renderMinutesAndSeconds = (milliseconds) => `
	${Math.floor(milliseconds / 60000)}:${`0${((milliseconds / 1000) % 60)}`.slice(-2)} s
`;

export const slashesToDashes = (text) => text.replace(/[-/]+/g, '_');

export const removeTags = (fieldText) => fieldText.replace(/(<([^>]+)>)/ig, '');
